/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { EventProto } from './event-proto';
import { FSEventProto } from './fsevent-proto';
import { FSFBViewDebug } from './fsfbview-debug';
import { FSFBViewRootProto } from './fsfbview-root-proto';
import { IntImagePair } from './int-image-pair';
import { IntPathPair } from './int-path-pair';
import { IntShaderPair } from './int-shader-pair';
import { TouchProto } from './touch-proto';
import { ViewRootProto } from './view-root-proto';

export class FrameRootProto {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): FrameRootProto {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFrameRootProto(bb: flatbuffers.ByteBuffer, obj?: FrameRootProto): FrameRootProto {
    return (obj || new FrameRootProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsFrameRootProto(
    bb: flatbuffers.ByteBuffer,
    obj?: FrameRootProto,
  ): FrameRootProto {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new FrameRootProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  frameIndex(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  frameTimestampMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  scanTimeUs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  identicalFramesSkipped(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  idleFramesSkipped(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  viewRoot(obj?: ViewRootProto): ViewRootProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset
      ? (obj || new ViewRootProto()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  images(index: number, obj?: IntImagePair): IntImagePair | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset
      ? (obj || new IntImagePair()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  imagesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  viewRoot2(obj?: FSFBViewRootProto): FSFBViewRootProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset
      ? (obj || new FSFBViewRootProto()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  paths(index: number, obj?: IntPathPair): IntPathPair | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset
      ? (obj || new IntPathPair()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  pathsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  shaders(index: number, obj?: IntShaderPair): IntShaderPair | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset
      ? (obj || new IntShaderPair()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  shadersLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  touches(index: number, obj?: TouchProto): TouchProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset
      ? (obj || new TouchProto()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  touchesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  keys(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readInt32(this.bb!.__vector(this.bb_pos + offset) + index * 4) : 0;
  }

  keysLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  keysArray(): Int32Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset
      ? new Int32Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  events(index: number, obj?: EventProto): EventProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset
      ? (obj || new EventProto()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  eventsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  previous(obj?: FrameRootProto): FrameRootProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset
      ? (obj || new FrameRootProto()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  fsEvents(index: number, obj?: FSEventProto): FSEventProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset
      ? (obj || new FSEventProto()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  fsEventsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  bytesUploaded(): number {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  viewDebugInfo(index: number, obj?: FSFBViewDebug): FSFBViewDebug | null {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset
      ? (obj || new FSFBViewDebug()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  viewDebugInfoLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  screenRootViewId64(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : BigInt('0');
  }

  static startFrameRootProto(builder: flatbuffers.Builder) {
    builder.startObject(18);
  }

  static addFrameIndex(builder: flatbuffers.Builder, frameIndex: number) {
    builder.addFieldInt32(0, frameIndex, 0);
  }

  static addFrameTimestampMs(builder: flatbuffers.Builder, frameTimestampMs: number) {
    builder.addFieldInt32(1, frameTimestampMs, 0);
  }

  static addScanTimeUs(builder: flatbuffers.Builder, scanTimeUs: number) {
    builder.addFieldInt32(2, scanTimeUs, 0);
  }

  static addIdenticalFramesSkipped(builder: flatbuffers.Builder, identicalFramesSkipped: number) {
    builder.addFieldInt32(3, identicalFramesSkipped, 0);
  }

  static addIdleFramesSkipped(builder: flatbuffers.Builder, idleFramesSkipped: number) {
    builder.addFieldInt32(4, idleFramesSkipped, 0);
  }

  static addViewRoot(builder: flatbuffers.Builder, viewRootOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, viewRootOffset, 0);
  }

  static addImages(builder: flatbuffers.Builder, imagesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, imagesOffset, 0);
  }

  static createImagesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startImagesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addViewRoot2(builder: flatbuffers.Builder, viewRoot2Offset: flatbuffers.Offset) {
    builder.addFieldOffset(7, viewRoot2Offset, 0);
  }

  static addPaths(builder: flatbuffers.Builder, pathsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, pathsOffset, 0);
  }

  static createPathsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startPathsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addShaders(builder: flatbuffers.Builder, shadersOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, shadersOffset, 0);
  }

  static createShadersVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startShadersVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addTouches(builder: flatbuffers.Builder, touchesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, touchesOffset, 0);
  }

  static createTouchesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startTouchesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addKeys(builder: flatbuffers.Builder, keysOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, keysOffset, 0);
  }

  static createKeysVector(
    builder: flatbuffers.Builder,
    data: number[] | Int32Array,
  ): flatbuffers.Offset;
  /**
   * @deprecated This Uint8Array overload will be removed in the future.
   */
  static createKeysVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset;
  static createKeysVector(
    builder: flatbuffers.Builder,
    data: number[] | Int32Array | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt32(data[i]!);
    }
    return builder.endVector();
  }

  static startKeysVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addEvents(builder: flatbuffers.Builder, eventsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(12, eventsOffset, 0);
  }

  static createEventsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startEventsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addPrevious(builder: flatbuffers.Builder, previousOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, previousOffset, 0);
  }

  static addFsEvents(builder: flatbuffers.Builder, fsEventsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(14, fsEventsOffset, 0);
  }

  static createFsEventsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startFsEventsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addBytesUploaded(builder: flatbuffers.Builder, bytesUploaded: number) {
    builder.addFieldInt32(15, bytesUploaded, 0);
  }

  static addViewDebugInfo(builder: flatbuffers.Builder, viewDebugInfoOffset: flatbuffers.Offset) {
    builder.addFieldOffset(16, viewDebugInfoOffset, 0);
  }

  static createViewDebugInfoVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startViewDebugInfoVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addScreenRootViewId64(builder: flatbuffers.Builder, screenRootViewId64: bigint) {
    builder.addFieldInt64(17, screenRootViewId64, BigInt('0'));
  }

  static endFrameRootProto(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }
}
